// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .feedback-modal-content {
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    position: relative;
    animation: slideIn 0.3s ease-out;
  }
  
  @keyframes slideIn {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  .feedback-modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #666;
    transition: color 0.2s;
  }
  
  .feedback-modal-close:hover {
    color: #333;
  }
  
  .feedback-modal-content h2, p{
    margin-top: 0;
    color: #333;
    font-size: 1.5rem;
  }
  
  .rating-container {
    margin: 20px 0;
  }
  
  .rating-container p {
    margin-bottom: 8px;
    font-weight: 500;
    color: black;
  }
  
  .stars {
    display: flex;
    gap: 8px;
  }
  
  .star-icon {
    cursor: pointer;
    font-size: 24px;
    color: #FFD700;
    transition: transform 0.2s;
  }
  
  .star-icon:hover {
    transform: scale(1.1);
  }
  
  .feedback-input, .email-input {
    margin-bottom: 16px;
  }
  
  .feedback-input label, .email-input label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
  }
  
  .feedback-input textarea, .email-input input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-family: inherit;
    font-size: 14px;
  }
  
  .feedback-input textarea:focus, .email-input input:focus {
    outline: none;
    border-color: #4CAF50;
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
  }
  
  .submit-feedback-btn {
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    transition: background-color 0.2s;
  }
  
  .submit-feedback-btn:hover {
    background-color: #45a049;
  }
  
  .submit-feedback-btn:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
  
  .thank-you-message {
    text-align: center;
    padding: 20px 0;
  }
  
  .submitted-rating {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;
  }
  
  /* Responsive adjustments */
  @media (max-width: 600px) {
    .feedback-modal-content {
      width: 95%;
      padding: 16px;
    }
    
    .star-icon {
      font-size: 20px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/5D-Thinking/FeedbackModal/FeedbackModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;IACf,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;IACE;MACE,UAAU;MACV,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".feedback-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .feedback-modal-content {\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 24px;\n    width: 90%;\n    max-width: 500px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    position: relative;\n    animation: slideIn 0.3s ease-out;\n  }\n  \n  @keyframes slideIn {\n    from {\n      transform: translateY(20px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n  \n  .feedback-modal-close {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: none;\n    border: none;\n    font-size: 18px;\n    cursor: pointer;\n    color: #666;\n    transition: color 0.2s;\n  }\n  \n  .feedback-modal-close:hover {\n    color: #333;\n  }\n  \n  .feedback-modal-content h2, p{\n    margin-top: 0;\n    color: #333;\n    font-size: 1.5rem;\n  }\n  \n  .rating-container {\n    margin: 20px 0;\n  }\n  \n  .rating-container p {\n    margin-bottom: 8px;\n    font-weight: 500;\n    color: black;\n  }\n  \n  .stars {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .star-icon {\n    cursor: pointer;\n    font-size: 24px;\n    color: #FFD700;\n    transition: transform 0.2s;\n  }\n  \n  .star-icon:hover {\n    transform: scale(1.1);\n  }\n  \n  .feedback-input, .email-input {\n    margin-bottom: 16px;\n  }\n  \n  .feedback-input label, .email-input label {\n    display: block;\n    margin-bottom: 6px;\n    font-weight: 500;\n  }\n  \n  .feedback-input textarea, .email-input input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-family: inherit;\n    font-size: 14px;\n  }\n  \n  .feedback-input textarea:focus, .email-input input:focus {\n    outline: none;\n    border-color: #4CAF50;\n    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);\n  }\n  \n  .submit-feedback-btn {\n    background-color: #4CAF50;\n    color: white;\n    border: none;\n    padding: 12px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    transition: background-color 0.2s;\n  }\n  \n  .submit-feedback-btn:hover {\n    background-color: #45a049;\n  }\n  \n  .submit-feedback-btn:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n  }\n  \n  .thank-you-message {\n    text-align: center;\n    padding: 20px 0;\n  }\n  \n  .submitted-rating {\n    display: flex;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 16px;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 600px) {\n    .feedback-modal-content {\n      width: 95%;\n      padding: 16px;\n    }\n    \n    .star-icon {\n      font-size: 20px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
